import type { RootState } from "@src/store/rootState";
import { selectedExperience } from "@src/store/slices/experiences";

import {
  getPutExperimentPayload,
  getPutStoredExperimentPayload,
} from "./getPutExperimentPayload";
import {
  getPutPersonalizationPayload,
  getPutStoredPersonalizationPayload,
} from "./getPutPersonalizationPayload";

export const getPutExperiencePayload = (state: RootState) => {
  const experience = selectedExperience(state);
  if (!experience) {
    return undefined;
  }

  return experience.category === "experiment"
    ? getPutExperimentPayload(state)
    : getPutPersonalizationPayload(state);
};

export const getPutStoredExperiencePayload = (state: RootState) => {
  const experience = selectedExperience(state);
  if (!experience) {
    return undefined;
  }

  return experience.category === "experiment"
    ? getPutStoredExperimentPayload(state)
    : getPutStoredPersonalizationPayload(state);
};
